import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import { errorPolicies as defaultOptions } from "@equiem/web-ng-lib";

export const globalGateway = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({ uri: process.env.gatewayUrl, fetch }),
  defaultOptions,
  name: "web-ng",
});
